import * as React from 'react';

import { useAuthenticationSubscription } from '../../hooks/useAuthenticationSubscription';
import { TReduxStore } from '../../types/redux';

interface ISubscriptionsContainerProps {
  reduxStore: TReduxStore;
}

export const SubscriptionsContainer: React.FC<ISubscriptionsContainerProps> = ({ reduxStore }) => {
  useAuthenticationSubscription({ reduxStore });

  return null;
};
